import { useMemo } from 'react';
import { useUserType } from 'store/features/auth/selectors';

import { isAutorizedUser } from 'common/utils/userTypes';

export const useIsAuthorizedUser = () => {
  const userType = useUserType();

  const isAuthorizedUser = useMemo(() => isAutorizedUser(userType),
    [userType]);

  return isAuthorizedUser;
};

export default useIsAuthorizedUser;
